







































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { StoreProductGroupMemberDetails } from "@/chipply/StoreProductGroupMemberDetailModel";
import ProductImageSlider from "./design-elements/ProductImageSlider.vue";
import { StoreProductGroupDetails } from "@/chipply/StoreProductGroupDetails";

@Component({
    components: {
        ProductImageSlider,
    },
})
export default class GroupProductSelector extends Vue {
    @Prop({ type: Object })
    public groupDetails!: StoreProductGroupDetails;

    @Prop({ type: Boolean })
    public isNotFirstProductGroupPageLoad!: boolean;

    public productSelected(model: StoreProductGroupMemberDetails) {
        this.$emit("productSelected", model);
    }
}
